import * as React from 'react'
import styled from 'styled-components'
import { GoogleButton } from './GoogleButton'
import { FacebookButton } from './FacebookButton'
import { LineButton } from './LineButton'
import { Link } from '../common/Link'
import { I18nCatalogue } from '../../i18n/auth/types'
import { AuthPageState } from './useAuthState'

interface Props {
  readonly catalogue: I18nCatalogue
  readonly pageState: AuthPageState
}

export function SocialAuth({ catalogue, pageState: { pageMode, setWithPassword } }: Props) {
  return (
    <>
      <Buttons>
        <GoogleButton href="/api/auth/google">{catalogue[pageMode].withGoogle}</GoogleButton>
        <FacebookButton href="/api/auth/facebook">{catalogue[pageMode].withFacebook}</FacebookButton>
        <LineButton href="/api/auth/line">{catalogue[pageMode].withLine}</LineButton>
      </Buttons>
      <ToPasswordAuth>
        <Link data-href style={{ color: 'inherit' }} onClick={() => setWithPassword(true)}>
          {catalogue[pageMode].orEmail}
        </Link>
      </ToPasswordAuth>
    </>
  )
}

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  [href] + [href] {
    margin-top: 1.5rem;
  }
`

const ToPasswordAuth = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  font-size: 0.9rem;
`
